$(window).scroll(function () {
    if ($(this).scrollTop() > 200) {
        if (!$(".herobg").hasClass("scroll")) {
            $(".herobg").addClass("scroll")
        }
    } else {
        $(".herobg").removeClass("scroll")
    }
});

if (!$('.home-hero-image')[0]) {
    $(".herobg").removeClass("herobg");
}


if ($(".js_open_menu")[0]) {
    $(".js_open_menu").on("click", function () {
        $("#navmenu").addClass("left-0");
        $("#navmenu").removeClass("-left-[150vw]");
    })
}

if ($(".js_close_menu")[0]) {
    $(".js_close_menu").on("click", function () {
        $("#navmenu").removeClass("left-0");
        $("#navmenu").addClass("-left-[150vw]");
    })
}